import React from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Paper,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SendIcon from "@mui/icons-material/Send";
import configServ from "../../services/config";
import axios from "axios";

const DocumentAnalyzerUI = () => {
  //#region
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  //   console.log("API_BASE_URL",API_BASE_URL)
  // console.log("ALL ENV", process.env);
  const fileInputRef = React.useRef(null);

  const [ocrText, setOcrText] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [result, setResult] = React.useState(null);
  const [resultQna, setResultQna] = React.useState(null);
  const [qnaText, setQnaText] = React.useState(null);
  const [loaderqna, setLoaderqna] = React.useState(false);

  const [extractOptions, setExtractOptions] = React.useState({
    technology: false,
    experience: false,
    skills: false,
    education: false,
  });

  const handleCheckboxChange = (e) => {
    setExtractOptions({
      ...extractOptions,
      [e.target.name]: e.target.checked,
    });
  };

  const isExtractDisabled = !Object.values(extractOptions).some(Boolean);

  const handleSummarize = async () => {
    setLoader(true);
    try {
      const res = await configServ.summarize({ ocrText: ocrText });
      if (res.status) {
        setResult(res.summary);
        console.log("Summarize Result:", res.data);
      }
    } catch (error) {
      console.error("Failed to fetch getways", error);
      setResult("Error in summarization. Please try again.");
    } finally {
      setLoader(false);
    }

    // yahin pe API call / ML logic aayega
    // summarizeAPI(ocrText)
  };

  const handleExtract = async () => {
    if (loader) return; // prevent double click

    setLoader(true);

    try {
      const trueOptions = Object.keys(extractOptions).filter(
        (key) => extractOptions[key]
      );

      if (trueOptions.length === 0) {
        setResult("Please select at least one field.");
        return;
      }

      const payload = {
        ocrText, // keep this short if possible
        fields: trueOptions, // only selected fields
      };

      console.log("Final Payload:", payload);
      const res = await configServ.extractFields(payload);
      if (res.status) {
        setResult(res.data);
        console.log("Summarize Result:", res.data);
      }
    } catch (error) {
      console.error("Extraction failed", error);
      setResult("Extraction failed. Try again.");
    } finally {
      setLoader(false);
    }
  };

  const handleReset = () => {
    setOcrText("");
    setLoading(false);
    setLoader(false);
    setResult(null);
    setResultQna(null);
    setQnaText("");
    setLoaderqna(false);

    setExtractOptions({
      technology: false,
      experience: false,
      skills: false,
      education: false,
    });

    // File input reset
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleQna = async () => {
    setLoaderqna(true);

    try {
      const payload = {
        ocrText, // keep this short if possible
        question: qnaText, // only selected fields
      };

      console.log("Final Payload:", payload);
      const res = await configServ.qna(payload);
      if (res.status) {
        setResultQna(res.answer);
        // console.log("Summarize Result:", res.data);
      }
    } catch (error) {
      console.error("Extraction failed", error);
      setResultQna("Qna failed. Try again.");
    } finally {
      setLoaderqna(false);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);

      const res = await axios.post(`${API_BASE_URL}/api/analyze`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status === 200) {
        console.log("API Response:", res.data.full_text);
        setOcrText(res.data.full_text);
      }
    } catch (error) {
      console.error("Upload error:", error);
      setOcrText("");
      alert("File upload failed");
    } finally {
      setLoading(false);
    }
  };

  //#endregion
  return (
    <Box sx={{ p: 2 }}>
      {/* Header */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
            Document Processing Dashboard
          </Typography>

          <Button variant="outlined" color="error" onClick={handleReset}>
            Reset
          </Button>
        </Box>
      </Paper>

      <Grid container spacing={2}>
        {/* LEFT SIDE */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2, height: "100%" }}>
            <Typography variant="subtitle1" gutterBottom>
              Upload Document
            </Typography>

            <Button
              variant="outlined"
              startIcon={<UploadFileIcon />}
              component="label"
              fullWidth
              disabled={loading}
            >
              {loading ? "Uploading..." : "Upload PDF / DOC / TXT"}
              <input
                hidden
                type="file"
                accept=".pdf,.doc,.docx,.txt"
                onChange={handleFileUpload}
                ref={fileInputRef}
              />
            </Button>

            <TextField
              label="Text"
              multiline
              rows={12}
              fullWidth
              sx={{ mt: 2 }}
              value={ocrText}
              onChange={(e) => setOcrText(e.target.value)}
            />
          </Paper>
        </Grid>

        {/* RIGHT SIDE */}
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            {/* Action Buttons */}
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Button
                variant="contained"
                fullWidth
                disabled={isExtractDisabled || !ocrText.trim()}
                onClick={handleExtract}
              >
                Extract
              </Button>

              <Button
                variant="outlined"
                fullWidth
                onClick={handleSummarize}
                disabled={!ocrText.trim() || loader}
              >
                Summarize
              </Button>
            </Box>

            {/* Extract Options */}
            <Typography variant="subtitle1">Extract Options</Typography>
            <Grid container>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="technology"
                      onChange={handleCheckboxChange}
                    />
                  }
                  label="Technology"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="experience"
                      onChange={handleCheckboxChange}
                    />
                  }
                  label="Experience (Years)"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox name="skills" onChange={handleCheckboxChange} />
                  }
                  label="Skills"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="education"
                      onChange={handleCheckboxChange}
                    />
                  }
                  label="Education"
                />
              </Grid>
            </Grid>

            {/* Extract Result */}
            <TextField
              label="Extract Result"
              multiline
              rows={6}
              fullWidth
              sx={{ mt: 2 }}
              value={result || ""}
            />

            {/* QNA SECTION */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                QnA
              </Typography>

              {/* Question Row */}
              <Box sx={{ display: "flex", gap: 1 }}>
                <TextField
                  placeholder="Ask your question..."
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  sx={{ mt: 2 }}
                  onChange={(e) => setQnaText(e.target.value)}
                />
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  sx={{ whiteSpace: "nowrap" }}
                  onClick={handleQna}
                  disabled={!ocrText.trim() || loaderqna}
                >
                  Send
                </Button>
              </Box>

              {/* Result */}
              <TextField
                label="QNA Result"
                multiline
                rows={6}
                fullWidth
                sx={{ mt: 2 }}
                value={resultQna || ""}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DocumentAnalyzerUI;
